/* ──────────────────────────────────────────────────────────────
   screens/Bundles/index.tsx · Bundles page
   Thin wrapper around the shared <BundleManager/> (also embedded on
   the Items screen) — provides the page title + scroll container.
   ────────────────────────────────────────────────────────────── */

import React from 'react';
import { View, Text, ScrollView } from 'react-native';

import { useTheme } from '../context/themeContext';
import BundleManager from './bundleManager';

export default function BundlesScreen() {
  const { theme } = useTheme();
  const { colors, fontSize, fontWeight, font } = theme;

  return (
    <ScrollView style={{ flex: 1, backgroundColor: colors.paper }} contentContainerStyle={{ padding: 24, paddingBottom: 64, maxWidth: 900 }}>
      <View style={{ marginBottom: 20 }}>
        <Text style={{ fontSize: fontSize['3xl'], fontWeight: fontWeight.semibold, color: colors.ink, fontFamily: font.sans, letterSpacing: -0.02 * fontSize['3xl'] }}>Bundles</Text>
        <Text style={{ fontSize: fontSize.md, color: colors.ink3, fontFamily: font.sans, marginTop: 4 }}>
          Compose an item from components. Dynamic bundles roll up their price from parts.
        </Text>
      </View>
      <BundleManager />
    </ScrollView>
  );
}
